import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import api from '../../core/api';
import {
  CircularProgress,
  TablePagination,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  Button,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import styles from './styles.module.css';
import Business from '../../models/Business';
import ListBusinessUsersItem from '../../components/ListBusinessUsersItem';
import Confirm from '../../components/Confirm';
import {useSnackbar} from 'notistack';

const ListBusinessManager = ({history}) => {
  const [users, setUsers] = useState([]);
  const [getEmpresas, setEmpresas] = useState([]);
  const [selectEmpresa, setSelectEmpresa] = useState('');
  const [firstLoading, setFirstLoading] = useState(true);
  const [isLoading, setIsFirstLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filterValue, setFilterValue] = useState('');
  const [onboarding, setOnboarding] = useState();
  const [error, setError] = useState(false);
  const adminGestor = JSON.parse(localStorage.getItem('adminGestor'));

  const {enqueueSnackbar} = useSnackbar();
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [debouncedFilterValue, setDebouncedFilterValue] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFilterValue(filterValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue]);

  const toggleEmail = email => {
    setSelectedEmails(prev =>
      prev.includes(email) ? prev.filter(e => e !== email) : [...prev, email],
    );
  };

  const removeSelected = async () => {
    if (selectedEmails.length === 0) return;

    const confirmar = await Confirm(
      `Deseja realmente remover ${selectedEmails.length} usuários do B2B?`,
    );

    if (confirmar) {
      setIsFirstLoading(true);
      try {
        await api.post('/business_users/unlink', {emails: selectedEmails});
        enqueueSnackbar('Usuários desvinculados com sucesso!', {
          variant: 'success',
        });
        fetchUsers();
        setSelectedEmails([]);
      } catch (err) {
        enqueueSnackbar('Erro ao desvincular usuários', {variant: 'error'});
        console.error(err);
      } finally {
        setIsFirstLoading(false);
      }
    }
  };

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleFilterChange = event => {
    setFilterValue(event.target.value);
    setCurrentPage(1);
  };

  const handleOnboarding = event => {
    setOnboarding(event.target.value);
    setCurrentPage(1);
  };

  async function fetchUsers() {
    try {
      if (users.length < 1) {
        setFirstLoading(true);
      }
      setIsFirstLoading(true);

      const filters = {
        name: filterValue,
        onboarding: onboarding,
        business_id: selectEmpresa,
        business_user_manager: true,
      };

      const {data} = await api.get('/business_users', {
        params: {
          page: currentPage,
          pageSize,
          filters,
          onboarding,
        },
      });
      setUsers(data.users);
      setTotalPages(data.totalUsers);
    } catch (err) {
      setError(true);
    } finally {
      setError(false);
      setFirstLoading(false);
      setIsFirstLoading(false);
    }
  }

  const fetchEmpresa = async () => {
    try {
      const allEmpresas = await Business.findAll();
      setEmpresas(allEmpresas);
    } catch (e) {
      // console.log({e});
    }
  };

  useEffect(() => {
    fetchEmpresa();
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [currentPage, pageSize, debouncedFilterValue, onboarding, selectEmpresa]);

  if (error) {
    return (
      <div>
        <p style={{textAlign: 'center'}}>Ocorreu um erro ao obter os dados.</p>
        <p style={{textAlign: 'center'}}>
          <a href="javascript:void(0)" onClick={fetchUsers}>
            Tentar novamente
          </a>
        </p>
      </div>
    );
  }

  return (
    <Dashboard>
      <div className={styles['filter-bar']}>
        <FormControl>
          <TextField
            variant="outlined"
            label="Buscar por"
            value={filterValue}
            onChange={handleFilterChange}
          />
        </FormControl>
        {adminGestor && (
          <FormControl>
            <InputLabel id="subscription-type-label">Onboarding?</InputLabel>
            <Select
              labelId="subscription-type-label"
              className={styles.select}
              variant="outlined"
              placeholder=""
              value={onboarding}
              onChange={handleOnboarding}>
              <MenuItem value={undefined}>Todos</MenuItem>
              <MenuItem value={true}>Sim</MenuItem>
              <MenuItem value={false}>Não</MenuItem>
            </Select>
          </FormControl>
        )}
        {adminGestor && (
          <FormControl>
            <InputLabel id="subscription-type-label">Empresa</InputLabel>
            <Select
              className={styles.select}
              variant="outlined"
              value={selectEmpresa}
              label="Selecione a empresa"
              onChange={e => setSelectEmpresa(e.target.value)}>
              {getEmpresas && [
                <MenuItem value={null}>Todos</MenuItem>,
                ...getEmpresas.map(e => {
                  return <MenuItem value={e.id}>{e.corporateName}</MenuItem>;
                }),
              ]}
            </Select>
          </FormControl>
        )}

        <div>
          {!window.location.pathname.match(/candidates/) && (
            <Button
              sx={{borderRadius: 10}}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => history.push(`${window.location.pathname}/add`)}>
              Adicionar Gestor
            </Button>
          )}
        </div>

        <div>
          <Button
            sx={{borderRadius: 10}}
            variant="contained"
            color="secondary"
            onClick={removeSelected}
            disabled={selectedEmails.length === 0}>
            Excluir Selecionados
          </Button>
        </div>
      </div>
      {firstLoading ? (
        <div className="flex-col center-a center-b" style={{height: '50vh'}}>
          <span style={{paddingTop: '10em'}}>
            <CircularProgress size={100} />
            <p> Carregando... </p>
          </span>
        </div>
      ) : (
        <div>
          <TablePagination
            component="div"
            count={totalPages}
            page={currentPage - 1}
            labelRowsPerPage={'Itens por página:'}
            onChangePage={handleChangePage}
            rowsPerPage={pageSize}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          {isLoading ? (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em'}}>
                <CircularProgress size={100} />
                <p> Carregando... </p>
              </span>
            </div>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Empresa</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map(user => (
                  <ListBusinessUsersItem
                    key={user.id}
                    user={user}
                    fetchUsers={fetchUsers}
                    toggleEmail={toggleEmail}
                    isSelected={selectedEmails.includes(user.email)}
                  />
                ))}
              </TableBody>
            </Table>
          )}
          <TablePagination
            component="div"
            count={totalPages}
            page={currentPage - 1}
            labelRowsPerPage={'Itens por página:'}
            onChangePage={handleChangePage}
            rowsPerPage={pageSize}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      )}
    </Dashboard>
  );
};

export default ListBusinessManager;
